// @flow

import {
  SET_LOBBY_CATEGORY,
  SET_LOBBY_FILTER,
  SET_LOBBY_GROUP_BY,
  SET_LOBBY_SPORT,
  SET_LOBBY_SUB_CATEGORY,
  TOGGLE_LOBBY_FILTER,
  RESET_LOBBY_FILTER,
  RESET_LOBBY_GROUP_BY,
  RESET_SELECTED_CHALLENGE,
  RESET_SPORT_CATEGORIES,
  SET_SELECTED_CHALLENGE,
  UNSET_LOBBY_FILTER
} from '../constants/actionTypes';
import {
  UPCOMING_CHALLENGES,
  UPCOMING_CUSTOM_CHALLENGES,
  UPCOMING_H2H_CHALLENGES
} from '../constants/apiTypes';
import {
  getUpcomingChallenges,
  getUpcomingCustomChallenges,
  getUpcomingH2HChallenges
} from '../api/challenges';
import { sendQuery, stopChallengePolls } from './challengeListActions';
import { token } from '../api/auth';

export function startLobbyPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { lobbyChallenges } = getState();

    dispatch(
      sendQuery({
        key: UPCOMING_CHALLENGES,
        query: getUpcomingChallenges,
        queryParams: {
          embed: ['rule_set'],
          status: 'running'
        },
        runStraightAway: force || !lobbyChallenges.isInitialised
      })
    );
  };
}

export function stopLobbyPoll() {
  return stopChallengePolls(UPCOMING_CHALLENGES);
}

export function startLobbyH2HPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { lobbyChallenges } = getState();

    dispatch(
      sendQuery({
        key: UPCOMING_H2H_CHALLENGES,
        query: getUpcomingH2HChallenges,
        queryParams: {
          embed: ['rule_set'],
          status: 'running'
        },
        runStraightAway: force || !lobbyChallenges.isH2HInitialised
      })
    );
  };
}

export function stopLobbyH2HPoll() {
  return stopChallengePolls(UPCOMING_H2H_CHALLENGES);
}

export function startLobbyCustomPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { lobbyChallenges } = getState();

    dispatch(
      sendQuery({
        key: UPCOMING_CUSTOM_CHALLENGES,
        token: token(),
        query: getUpcomingCustomChallenges,
        queryParams: {
          embed: ['rule_set'],
          status: 'running'
        },
        runStraightAway: force || !lobbyChallenges.isCustomChallengeInitialised
      })
    );
  };
}

export function stopLobbyCustomPoll() {
  return stopChallengePolls(UPCOMING_CUSTOM_CHALLENGES);
}

export function setLobbyCategory(category) {
  return {
    type: SET_LOBBY_CATEGORY,
    category
  };
}

export function setLobbyFilter(key, value) {
  return {
    type: SET_LOBBY_FILTER,
    key,
    value
  };
}

export function unsetLobbyFilter(key) {
  return {
    type: UNSET_LOBBY_FILTER,
    key
  };
}

export function toggleLobbyFilter(key, value, opts = {}) {
  const { resetFilters } = opts;
  return {
    type: TOGGLE_LOBBY_FILTER,
    key,
    value,
    resetFilters
  };
}

export function resetLobbyFilter(sport) {
  return {
    type: RESET_LOBBY_FILTER,
    sport
  };
}

export function resetSportCategories() {
  return {
    type: RESET_SPORT_CATEGORIES
  };
}

export function setLobbyGroupBy(key) {
  return {
    type: SET_LOBBY_GROUP_BY,
    key
  };
}

export function resetLobbyGroupBy(sport) {
  return {
    type: RESET_LOBBY_GROUP_BY,
    sport
  };
}

export function setLobbySport(sport: string, subCategory?: string) {
  return {
    type: SET_LOBBY_SPORT,
    sport,
    subCategory
  };
}

export function setSelectedChallenge(challengeId: string) {
  return {
    type: SET_SELECTED_CHALLENGE,
    challengeId
  };
}

export function resetSelectedChallenge() {
  return {
    type: RESET_SELECTED_CHALLENGE
  };
}

export function setLobbySubCategory(sport: string) {
  return {
    type: SET_LOBBY_SUB_CATEGORY,
    sport
  };
}
